


































































































































































import { computed, ref, useRoute, useRouter, defineComponent, onMounted, watch, nextTick } from '@nuxtjs/composition-api';
import { SfHeading, SfButton, SfCallToAction, SfLink, SfLoader } from '@storefront-ui/vue';
import { addBasePath } from '~/helpers/addBasePath';
import { useUser } from '~/modules/customer/composables/useUser';
import useTrackMyOrder from "~/modules/czar/trackMyOrder/trackMyOrder";
import jsPDF from "jspdf";
import "jspdf-autotable";

declare global {
  interface Window {
    sa_values: {
      site: "31975";
      token: "8868mRsc";
    };
    sa_products : {}
  }
  interface Window {
    _bambuser?: {
      collect: (data: any) => void;
    };
  }
}

export default defineComponent({
  components: {
    SfHeading,
    SfButton,
    SfCallToAction,
    SfLink,
    SfLoader
  },
  setup(props, context) {
    const { isAuthenticated } = useUser();
    context.emit('changeStep', 4);
    const route = useRoute();
    const router = useRouter();
    const { useTrackOrder } = useTrackMyOrder();
    const companyDetails = ref({
      name: 'Midwest Photo Headquarter',
      street: '2887 Silver Drive, OH 43211',
      city: 'Columbus , Ohio',
      email: 'mpex@mpex.com',
    });
    const user_email = ref<any | null>(null);
    const orderdetail = ref<any | null>(null);
    const loading = ref<boolean>(true);
    const orderNumber = computed(() => route.value.query.order ?? '');
    const orderEmail = computed(() => route.value.query.email ?? '');

    const getSingleQueryParam = (param: string | string[] | undefined): string => {
      if (Array.isArray(param)) {
        return param[0] || '';
      }
      return param || '';
    };

    if (isAuthenticated.value && typeof window !== 'undefined' && window.localStorage) {
      user_email.value = localStorage.getItem('mp_customer_email');
    } else {
      const emailParam = getSingleQueryParam(orderEmail.value);
      user_email.value = emailParam ? decodeURIComponent(emailParam) : '';
    }
  
    if(process.client){
      //@ts-ignore
      window.dataLayer = window.dataLayer || [];
      //@ts-ignore
      window.dataLayer.push({
        event: "purchase"
      });
    }


    if (user_email && orderNumber) {
      var queryVariables = {
        email: user_email.value,
        order_id: orderNumber.value,
      };
      try {
        useTrackOrder(queryVariables).then((detail) => {
          orderdetail.value = detail.trackMyOrder.value;
          loading.value = detail.loading.value;
          if (loading.value == false) {
            subscriptionwidget();
            initShopperApproved();
          }
        });
      } catch (error) {
        router.push({ path: "/" });
      }
    }

    const generatePdf = () => {
      const pdf = new jsPDF();

      const logoUrl = "/homepage/header/logo.png";
      pdf.addImage(logoUrl, "PNG", 10, 10, 40, 15);

      pdf.setFontSize(20);
      pdf.text(`#Order ID: ${orderNumber.value}`, 10, 60);
      pdf.setFontSize(10);
      pdf.text(`Order Status: ${orderdetail?.value?.status}`, 10, 70);
      const order_date = orderdetail?.value?.order_date;
      const formattedOrderDate = order_date ? new Date(order_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'N/A';
      pdf.text(`Order Date: ${formattedOrderDate}`, 10, 80);
      pdf.setFontSize(18);
      pdf.text("Items Ordered", 10, 100);

      const orderItems = orderdetail?.value?.items;
      const shipping_address = orderdetail?.value?.shipping_address;
      const billing_address = orderdetail?.value?.billing_address;

      const tableHeaders = [
        { title: "PRODUCT NAME", dataKey: "product_name" },
        { title: "SKU", dataKey: "product_sku" },
        { title: "PRICE", dataKey: "product_price" },
        { title: "QTY", dataKey: "product_qty" },
        { title: "SUBTOTAL", dataKey: "subtotal" },
      ];

      const tableData = orderItems.map(item => ({
        product_name: item.product_name,
        product_sku: item.product_sku,
        product_price: `$${item.product_price}`,
        product_qty: item.product_qty,
        subtotal: `$${item.subtotal}`,
      }));

      let totalSubtotal = 0;
      let totalShipping = 0;
      orderItems.forEach((item) => {
        totalSubtotal += parseFloat(item.subtotal || '0');
        totalShipping += parseFloat(item.shipping_amount || '0');
      });
      const grandTotal = totalSubtotal + totalShipping;
      const formatCurrency = (value) => {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(value);
      };
      // @ts-ignore
      pdf.autoTable({
        head: [tableHeaders],
        body: tableData.map((item) => [
              item.product_name,
              item.product_sku,
              item.product_price,
              item.product_qty,
              item.subtotal,
            ]),
        startY: 90,
        margin: { top: 10, left: 10, right: 10 },
        theme: 'grid',
        headStyles: {
          fillColor: [250, 159, 39],
          textColor: [255, 255, 255],
        },

        bodyStyles: {
          lineWidth: 0,
          lineColor: [255, 255, 255],
        },
      });
      const startY = 90;
      const rowHeight = 10;
      const tableHeight = tableData.length * rowHeight;
      const tableBottomY = startY + tableHeight;
      const pageWidth = pdf.internal.pageSize.width;
      const sub_total = `Subtotal: ${formatCurrency(totalSubtotal)}`;
      const total_shipping = `Shipping: ${formatCurrency(totalShipping)}`;
      const grand_total = `Grand Total: ${formatCurrency(grandTotal)}`;
      const sub_totaltextWidth = pdf.getTextWidth(sub_total);
      const total_shippingtextWidth = pdf.getTextWidth(total_shipping);
      const grand_totaltextWidth = pdf.getTextWidth(grand_total);
      const sub_totalxPosition = pageWidth - sub_totaltextWidth + 4;
      const total_shippingxPosition = pageWidth - total_shippingtextWidth + 5;
      const grand_totalxPosition = pageWidth - grand_totaltextWidth + 8;
      pdf.setFontSize(10);
      pdf.line(10, tableBottomY + 5, pageWidth - 10, tableBottomY + 5);
      pdf.text(sub_total, sub_totalxPosition, tableBottomY + 10);
      pdf.text(total_shipping, total_shippingxPosition, tableBottomY + 15);
      pdf.text(grand_total, grand_totalxPosition, tableBottomY + 20);
      pdf.line(10, tableBottomY + 25, pageWidth - 10, tableBottomY + 25);
      pdf.setFontSize(18);
      pdf.text("ORDER INFORMATION", 10, tableBottomY + 40);
      pdf.setFontSize(14);
      pdf.text("Shipping Address", 10, tableBottomY + 50);
      pdf.setFontSize(10);
      pdf.text(shipping_address.name, 10, tableBottomY + 55);
      pdf.text(shipping_address.street, 10, tableBottomY + 60);
      pdf.text(`${shipping_address.city}, ${shipping_address.state}, ${shipping_address.postcode}`, 10, tableBottomY + 65);
      pdf.text(shipping_address.country, 10, tableBottomY + 70);
      pdf.text(`T: ${shipping_address.telephone}`, 10, tableBottomY + 75);
      pdf.setFontSize(14);
      pdf.text("Shipping Method", 10, tableBottomY + 85);
      pdf.setFontSize(10);
      const margin = 10; // Set a margin for text
      const usableWidth = pageWidth - margin * 2; // Calculate usable width for text
      const shippingMethod = orderdetail?.value?.shipping_method || "Unknown Shipping Method";
      const wrappedText = pdf.splitTextToSize(shippingMethod, usableWidth);
      pdf.text(wrappedText, 10, tableBottomY + 90);
      /* pdf.text(orderdetail?.value?.shipping_method, 10, tableBottomY + 90); */
      pdf.setFontSize(14);
      pdf.text("Billing Address", 10, tableBottomY + 100);
      pdf.setFontSize(10);
      pdf.text(billing_address.name, 10, tableBottomY + 105);
      pdf.text(billing_address.street, 10, tableBottomY + 110);
      pdf.text(`${billing_address.city}, ${billing_address.state}, ${billing_address.postcode}`, 10, tableBottomY + 115);
      pdf.text(billing_address.country, 10, tableBottomY + 120);
      pdf.text(`T: ${billing_address.telephone}`, 10, tableBottomY + 125);
      pdf.setFontSize(14);
      pdf.text("Payment Method", 10, tableBottomY + 135);
      pdf.setFontSize(10);
      pdf.text(orderdetail?.value?.payment_method, 10, tableBottomY + 140);

      // Generate a Blob URL and open it in a new tab
      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");

      // Optional: Provide a download option (not automatic)
      // Uncomment the line below to download directly instead of opening in a new tab
      // pdf.save("order-receipt.pdf");
    };

    const conversionItems = ref("");
    const subscriptionItems = ref("");
    const orderProductIds = ref<number[]>([]);
    const grandTotal = ref('');

    onMounted(() => {
      /* if (process.client) {
        setTimeout(() => {
          window.sa_values = {
            site: "31975",
            token: "8868mRsc"
          };
          const orderItems = orderdetail.value?.items ?? [];
          const orderItemData = [];
          
          orderItems.forEach(item => {
            orderItemData[item.sku] = item.name;
          });

          let sa_products;
          try {
            sa_products = orderItemData;
          } catch (e) {
            sa_products = {};
          }

          window.sa_products = sa_products;

          function saLoadScript(src) {
            var js = document.createElement("script");
            js.src = src;
            js.type = "text/javascript";
            document.getElementsByTagName("head")[0].appendChild(js);
          }

          saLoadScript("https://www.shopperapproved.com/thankyou/rate/31975.js");
        }, 500);
      } */
    });

    const initShopperApproved = () => {
      if (process.client) {
        setTimeout(() => {
          window.sa_values = {
            site: "31975",
            token: "8868mRsc"
          };

          const orderItems = orderdetail.value?.items ?? [];
          console.log('orderItems');
          console.log(orderItems);
          const orderItemData = {};

          orderItems.forEach(item => {
            orderItemData[item.product_sku] = item.product_name;
          });

          window.sa_products = orderItemData;

          function saLoadScript(src) {
            const js = document.createElement("script");
            js.src = src;
            js.type = "text/javascript";
            document.getElementsByTagName("head")[0].appendChild(js);
          }

          saLoadScript("https://www.shopperapproved.com/thankyou/rate/31975.js");
        }, 500);
      }
    };


    const subscriptionwidget = () => {
      const orderItems = orderdetail.value?.items ?? [];

      let totalSubtotal = 0;
      let totalShipping = 0;
      orderItems.forEach((item) => {
        totalSubtotal += parseFloat(item.subtotal || '0');
        totalShipping += parseFloat(item.shipping_amount || '0');
      });
      grandTotal.value = (totalSubtotal + totalShipping).toFixed(2);

      if (orderItems.length > 0) {
        conversionItems.value = orderItems
          .map((item, index) => `&sku${index}=${item.product_sku}&product_id${index}=${item.id}&price${index}=${item.product_price}`)
          .join("");
        subscriptionItems.value = orderItems
          .map((item, index) => `${item.id}, ${item.product_name};`)
          .join("");
        orderProductIds.value = orderItems.map((item) => item.id);
      }

      nextTick(() => {
        if (process.client) {
          const reviewDiv = document.getElementById("give-review");
          if (reviewDiv) {
            const script = document.createElement("script");
            script.src = "https://mpex.services.answerbase.com/javascript/widget/subscription-widget.js";
            script.type = "text/javascript";
            script.setAttribute("data-title", "Share your expertise to qualify for special offers");
            script.setAttribute("data-checkbox-text", "I'd like to answer questions related to these topics and products");
            script.setAttribute("data-button-text", "Sign Up");
            script.setAttribute("data-products", subscriptionItems.value);
            script.setAttribute("data-category-ids", "");
            script.setAttribute("data-category-externalids", "");
            script.setAttribute("data-tags-ids", "");
            script.setAttribute("data-tags-externalids", "");
            script.setAttribute("data-insert-after", "");

            reviewDiv.appendChild(script);
          } else {
            console.warn("Element #give-review not found");
          }
          loadBambuserScript();
        }
      });
    }

    const onPurchase = () => {
      if (typeof window._bambuser) {
        const data = {
          event: "purchase",
          orderId: orderNumber.value,
          orderValue: grandTotal.value.toString(),
          orderProductIds: orderProductIds.value,
          currency: "USD",
        };

        window._bambuser.collect(data);
        console.log("Bambuser Purchase Event Sent:");
      } else {
        console.warn("Bambuser tracking library not loaded yet.");
      }
    }

    const loadBambuserScript = () => {
      const bamSrcElm = document.createElement("script");
      bamSrcElm.src = "https://cdn.liveshopping.bambuser.com/metrics/bambuser.min.js";
      bamSrcElm.onload = onPurchase;
      document.head.appendChild(bamSrcElm);
    }

    return {
      isAuthenticated,
      addBasePath,
      companyDetails,
      orderNumber,
      generatePdf,
      orderdetail,
      conversionItems,
      subscriptionItems,
      orderProductIds,
      grandTotal,
      user_email,
      loading
    };
  },
});
